import trace from './lib/trace';

import envSpecific from './env-configuration';
import appVersion from './app-version';

const config = {
  version: appVersion,
  fetchHandlerProbe: 'https://bahnkick-fetch-handler',
  apiHeaders: () => {
    return {
      'subscription-key': '40b4a46c98e648f494285465a0b8460f',
    };
  },
  ...envSpecific,
};

trace('Loaded configuration', config);

export default config;
